import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppTilesModule } from '../app-tiles/app-tiles.module';
import { LazyViewModule } from '../lazy-view/lazy-view.module';
import { BackButtonModule } from '../shared/back-button/back-button.module';
import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { TitleAnnouncerModule } from '../shared/title-announcer/title-announcer.module';
import { HeroComponent } from './hero.component';

@NgModule({
    imports: [
        AppTilesModule,
        BackButtonModule,
        CommonModule,
        IconFontModule,
        LazyViewModule,
        SharedComponentsModule,
        TitleAnnouncerModule
    ],
    declarations: [
        HeroComponent
    ],
    exports: [
        HeroComponent
    ]
})
export class HeroModule { }
